<template>
  <div class="header-height">
    <div id="myHeader">
      <div class="page-header min-w" >
        <div class="show-w">
          <div class="logo" @click="toIndex">
            <img src="../assets/logo.png"/>
          </div>
          <div class="explain">
            打造中国运营的企业营销服务提供商
          </div>
          <div class="other">
            <div class="voice">
              <span @click="changeLang('zh')" :class="{'click':lang=='zh'}">简</span> |
              <span @click="changeLang('zh_tw')" :class="{'click':lang=='zh_tw'}">繁</span> |
              <span @click="changeLang('en')" :class="{'click':lang=='en'}">EN</span>
            </div>
            <div class="telephone">

            </div>
          </div>
        </div>
      </div>
      <PageMenu :getArray="getArray"></PageMenu>
    </div>
  </div>
</template>

<script>
import PageMenu from "./PageMenu";
import i18n from '../lang'
export default {
  name: 'PageHeader',
  data () {
    return {
      lang:localStorage.getItem('lang')?localStorage.getItem('lang'):'zh'
    }
  },
  components:{
    PageMenu
  },
  props:{
    getArray:{
      type:Function,
      default:()=>{
        return [];
      }
    }
  },
  methods:{
    toIndex(){
      this.$router.push('/');
      window.scrollTo(0,0);
    },
    changeLang(lang){
      this.lang = lang;
      i18n.locale = lang
      localStorage.setItem('lang',lang)
      if(this.$route.path=='/notice'||this.$route.path=='/file'||this.$route.path=='/report'||this.$route.path=='/news'){
        return
      }
      if(lang=='en'||lang=='zh_tw'){
        this.$router.push({path:'/notice',query:{t:Date.now()}});
      }
      // location.reload();
    }
  },
  mounted() {
    window.onscroll = function() {
      let zoom = window.sessionStorage.getItem('zoom');
      let sl = -Math.max(document.body.scrollLeft,document.documentElement.scrollLeft);
      document.getElementById('myHeader').style.left = sl/zoom + 'px';
    }
    window.setMyLang = this.changeLang;
  }
}
</script>

<style scoped>
  .header-height{
    width: 100%;
    height: 150px;
  }
  #myHeader{
    width: 100%;
    z-index: 99;
    position: fixed;
    min-width: 1180px;
  }
  .page-header{
    background: #FFFFFF;
    width: 100%;
  }
  .page-header .explain{
    margin-left: 120px;
    font-size: 18px;
    line-height: 90px;
    text-align: left;
    color: #FD6720;
    font-weight: 400;
    float: left;
  }
  .page-header .logo{
    float: left;
    cursor: pointer;
  }
  .page-header .logo img{
    margin: 20px 0;
    height: 49px;
    width: 172px;
  }
  .page-header .other{
    line-height: 25px;
    padding: 20px 0;
    text-align: right;
    color: #808080;
    float: right;
    margin-right: 20px;

    height: 90px;
    display: flex;
    align-items: center;
  }
  .page-header .other .voice{
    font-size: 14px;
  }
  .page-header .other .voice .click{
    color: #FF722F;
  }
  .page-header .other .voice span{
    cursor: pointer;
  }
  .page-header .other .telephone{
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue